import "./Contador.css";

const Contador = ({ numDo, counts }) => {
  const { padres = 0, hijos = 0, otros = 0 } = counts || {};

  return (
    <div className="mb-3">
      <div className="do-bar">
        <div className="do-bar__left">
          <span className="do-bar__badge">DO</span>
          <span className="do-bar__number">
            Número: <span>{numDo}</span>
          </span>
        </div>
        <div className="do-bar__stats">
          <div className="do-bar__stat">
            <div className="do-bar__stat-n do-bar__stat-n--padres">{padres}</div>
            <div className="do-bar__stat-l">Padres</div>
          </div>
          <div className="do-bar__stat">
            <div className="do-bar__stat-n do-bar__stat-n--hijos">{hijos}</div>
            <div className="do-bar__stat-l">Hijos</div>
          </div>
          <div className="do-bar__stat">
            <div className="do-bar__stat-n do-bar__stat-n--otros">{otros}</div>
            <div className="do-bar__stat-l">Otros</div>
          </div>
        </div>
      </div>
      <div className="do-bar__legend">
        <div className="do-bar__ley">
          <div className="do-bar__ley-bar do-bar__ley-bar--padres"></div> Documento Padre
        </div>
        <div className="do-bar__ley">
          <div className="do-bar__ley-bar do-bar__ley-bar--hijos"></div> Documento Hijo
        </div>
        <div className="do-bar__ley">
          <div className="do-bar__ley-bar do-bar__ley-bar--otros"></div> Otro Documento
        </div>
      </div>
    </div>
  );
};

export default Contador;
